import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import classNames from "classnames";
import ArrowSVG from "../../assets/svgs/arrow.svg";
import styles from "./DataInputHeaderSelect.module.scss";

/**
 * Data Input toolbar select only — uses MUI Menu (portal) so menus are not clipped
 * by header overflow/scroll. Does not replace the shared DropDown component.
 */
const DataInputHeaderSelect = ({
	options,
	selected,
	onChange,
	width = 172,
	wide = false,
	className,
	"aria-label": ariaLabel,
}) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const selectedOption = options.find((el) => el.value === selected);
	const menuWidth = wide ? Math.max(width, 280) : width;

	const handleOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSelect = (value) => {
		onChange(value);
		handleClose();
	};

	return (
		<>
			<button
				type="button"
				className={classNames(styles.trigger, open && styles.open, wide && styles.wide, className)}
				onClick={handleOpen}
				aria-label={ariaLabel || selectedOption?.label || "Select option"}
				aria-haspopup="listbox"
				aria-expanded={open}
			>
				<span className={styles.label}>
					{selectedOption?.label || "Please select"}
				</span>
				<span className={classNames(styles.arrow, open && styles.arrowOpen)}>
					<ArrowSVG />
				</span>
			</button>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				disableScrollLock
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
				transformOrigin={{ vertical: "top", horizontal: "left" }}
				PaperProps={{
					className: styles.menuPaper,
					sx: {
						width: anchorEl?.offsetWidth || menuWidth,
						minWidth: menuWidth,
					},
				}}
				MenuListProps={{
					className: styles.menuList,
					dense: true,
				}}
			>
				{options.map((option) => (
					<MenuItem
						key={option.value}
						selected={option.value === selected}
						onClick={() => handleSelect(option.value)}
						className={classNames(
							styles.menuItem,
							option.value === selected && styles.selected,
							option.subOption && styles.subOption,
							option.subOption === false && styles.mainOption
						)}
					>
						{option.label}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default DataInputHeaderSelect;
